<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row
      class="fill-height"
      align="center"
      justify="center"
      style="padding: 0% 2.5% 0% 2.5%"
    >
      <v-col
        align="center"
        justify="center"
        style="padding-bottom: 0%; height: 100%;"
        :cols="colSize"
      >
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <v-img
          src="../../public/static/Text Background 1.png"
          width="fit-content"
        />
        <v-card
          class="text-left slide-card"
          style="max-height: 70%; height: 100%; overflow-y: auto;"
        >
          <div class="slide-content">
            <h1 class="text-center">
              {{ $t("message.slideFourPanelOneTitle") }}
            </h1>
            <br />
            <ul v-html="$t(`message.slideFourPanelOneDetails`)"></ul>
          </div>
        </v-card>
        <v-img src="../../public/static/Text Background 2.png" />
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        />
      </v-col>
      <v-col
        align="center"
        justify="center"
        style="padding-bottom: 0%; height: 100%;"
        :cols="colSize"
      >
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <v-img
          src="../../public/static/Text Background 1.png"
          width="fit-content"
        />
        <v-card
          class="text-left slide-card"
          style="max-height: 70%; height: 100%; overflow-y: auto;"
        >
          <div
            @click="toggleMap = true"
            class="slide-content"
            style="max-width: 100%; cursor: pointer;"
          >
            <h1 class="text-center">
              {{ $t("message.slideFourPanelTwoTitle") }}
            </h1>
            <br />
            <v-img src="../../public/static/Study Area Map.png" contain />
          </div>
        </v-card>
        <v-img
          src="../../public/static/Text Background 2.png"
          width="fit-content"
        />
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        />
      </v-col>

      <v-col
        align="center"
        justify="center"
        style="padding-bottom: 0%; height: 100%;"
        :cols="colSize"
      >
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <v-img
          src="../../public/static/Text Background 1.png"
          width="fit-content"
        />
        <v-card
          class="text-left slide-card"
          style="max-height: 70%; height: 100%; overflow-y: auto;"
        >
          <div class="slide-content">
            <h1 class="text-center">
              {{ $t("message.slideFourPanelThreeTitle") }}
            </h1>
            <br />
            <ul v-html="$t(`message.slideFourPanelThreeDetails`)"></ul>
          </div>
        </v-card>
        <v-img
          src="../../public/static/Text Background 2.png"
          width="fit-content"
        />
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
          eager
        />
      </v-col>
      <v-dialog v-model="toggleMap">
        <div class="text-right" style="background: antiquewhite;">
          <v-btn class="text-right" @click="toggleMap = false">X</v-btn>
        </div>
        <v-card color="gray" class="gray-background">
          <v-img
            src="../../public/static/Study Area Map.png"
            contain
            style="height: 125vh;"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "BackgroundInformation",
  data() {
    return {
      toggleMap: false
    };
  },
  computed: {
    colSize() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) {
        return "12";
      }
      return "4";
    },
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "40%";
      }
      return "25%";
    },
    easelBottom() {
      return "100%";
    }
  }
};
</script>
